import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
const Aboutus = () => {
    
const testimonials = [
  {
    name: "Hazel Jenkins",
    role: "Ceo & Founder",
    rating: 5,
    feedback:
      "Passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which evenhtly believable.",
  },
  {
    name: "Dylan Wang",
    role: "Manager",
    rating: 4,
    feedback:
      "Passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which evenhtly believable.",
  },
  {
    name: "Naomi Violet",
    role: "Manager",
    rating: 5,
    feedback:
      "Passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which evenhtly believable.",
  },
  {
    name: "Parsons William",
    role: "Co Founder",
    rating: 5,
    feedback:
      "Passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which evenhtly believable.",
  },
  {
    name: "Ariana Green",
    role: "Satisfied Client",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellemt trainers. Thank you all!",
  },
  {
    name: "Justin Aria",
    role: "Customer",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellemt trainers. Thank you all!",
  },
];
  return (
    <div className="page-wrapper">
        {/* <!-- Title Bar --> */}
       
        {/* <!-- Title Bar End--> */}

        {/* <!-- Page Content --> */}
        <div className="page-content">

            {/* <!-- About-us start -->  */}
            <section className="about-section-two section-md">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 eagle-left-col">
                            <div className="about-image">
                                <div className="about-contant">
                                    <div className="pbminfotech-ele-fid-style-2">
                                        <div className="eagle-fld-contents">
                                            <div className="eagle-fld-wrap">
                                                <h4 className="eagle-fid-inner">
                                                    <span className="eagle-fid-before"><sup>*</sup></span>
                                                    <span className="eagle-number-rotate" data-appear-animation="animateDigits" data-from="0" data-to="235" data-interval="5" data-before="" data-before-style="" data-after="" data-after-style="">235</span>
                                                    <span className="eagle-fid"><sup>+</sup></span>
                                                </h4>
                                            </div>
                                            <div className="eagle-fid-icon-title">      
                                                <span className="eagle-fid-title">Happy Customers</span>
                                            </div>
                                        </div>
                                        <div className="eagle-sticky-corner eagle-bottom-left-corner">
                                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30 30V0C30 16 16 30 0 30H30Z"></path>
                                            </svg>
                                        </div>
                                        <div className="eagle-sticky-corner eagle-top-right-corner">
                                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30 30V0C30 16 16 30 0 30H30Z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 eagle-right-col">
                            <div className="about-wrap">
                                <div className="eagle-heading-subheading animation-style2">
                                    <h4 className="eagle-subtitle">
                                    <span></span>
                                    About Eagle OBC
                                    </h4>
                                    <h2 className="eagle-title">Innovating Logistics, Ensuring Excellence</h2>
                                    <div className="eagle-heading-desc">The efficiency and reliability of transport systems play a crucial role in connecting communities.
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="ihbox-bg">
                                            <div className="eagle-ihbox-style-1">
                                                <div className="eagle-ihbox-headingicon">
                                                    <div className="eagle-ihbox-icon">
                                                        <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-icon">
                                                            <div className="eagle-icon-wrapper eagle-icon-type-icon">
                                                                <i className="flaticon-planet-earth"></i>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                    <div className="eagle-ihbox-contents">  
                                                        <h2 className="eagle-element-title">Worldwide Services</h2>     
                                                        <div className="eagle-heading-desc">We’re always provide people a complete solution focused of any business.</div>            
                                                    </div>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="ihbox-inner">
                                            <div className="eagle-ihbox-style-1">
                                                <div className="eagle-ihbox-headingicon">
                                                    <div className="eagle-ihbox-icon">
                                                        <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-icon">
                                                            <div className="eagle-icon-wrapper eagle-icon-type-icon">
                                                                <i className="flaticon-truck"></i>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                    <div className="eagle-ihbox-contents">  
                                                        <h2 className="eagle-element-title">Local Service</h2>      
                                                        <div className="eagle-heading-desc">We’re always provide people a complete solution focused of any business.</div>          
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="about-button">
                                    <Link to="/about-us" className="eagle-btn eagle-btn-blackish" >
                                   
                                        <span className="eagle-button-text">Know More</span>    
                                        <span className="eagle-button-icon-wrapper">
                                            <span className="eagle-button-icon">
                                                <i className="eagle-base-icon-black-arrow-1"></i>       
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </section>            
            {/* <!-- About-us End -->  */}

            

            {/* <!-- Fid Start -->  */}
            <section className="fid-section-three fid-ele section-lgb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-xl-3">
                            <div className="fid-wrap">
                                <div className="pbminfotech-ele-fid-style-6">
                                    <div className="d-flex gap-3 flex-colume">
                                        <h4 className="eagle-fid-inner">
                                            <span className="eagle-fid-before"> <i className="flaticon-air-plane"></i></span>
                                        </h4>
                                        <div>
                                            <h3>                                                
                                                <span className="eagle-number-rotate" data-appear-animation="animateDigits" data-from="0" data-to="165" data-interval="5" data-before="" data-before-style="" data-after="" data-after-style="">165</span>
                                                <span className="eagle-fid"></span>
                                            </h3>                                            
                                            <h6 className="eagle-fid-title">Product delivery</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3">
                            <div className="fid-wrap">
                                <div className="pbminfotech-ele-fid-style-6">
                                    <div className="d-flex gap-3 flex-colume">
                                        <h4 className="eagle-fid-inner">
                                            <span className="eagle-fid-before"> <i className="flaticon-parcels"></i></span>
                                        </h4>
                                        <div>
                                            <h3>                                                
                                                <span className="eagle-number-rotate" data-appear-animation="animateDigits" data-from="0" data-to="42" data-interval="5" data-before="" data-before-style="" data-after="" data-after-style="">42</span>
                                                <span className="eagle-fid">+</span>
                                            </h3>                                            
                                            <h6 className="eagle-fid-title">Winning Awards</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-xl-3">
                            <div className="fid-wrap">
                                <div className="pbminfotech-ele-fid-style-6">
                                    <div className="d-flex gap-3 flex-colume">
                                        <h4 className="eagle-fid-inner">
                                            <span className="eagle-fid-before"> <i className="flaticon-parcel"></i></span>
                                        </h4>
                                        <div>
                                            <h3>                                                
                                                <span className="eagle-number-rotate" data-appear-animation="animateDigits" data-from="0" data-to="12" data-interval="5" data-before="" data-before-style="" data-after="" data-after-style="">12</span>
                                                <span className="eagle-fid">+</span>
                                            </h3>                                            
                                            <h6 className="eagle-fid-title">Years Experience</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-xl-3">
                            <div className="fid-wrap">
                                <div className="pbminfotech-ele-fid-style-6">
                                    <div className="d-flex gap-3 flex-colume">
                                        <h4 className="eagle-fid-inner">
                                            <span className="eagle-fid-before"> <i className="flaticon-protected"></i></span>
                                        </h4>
                                        <div>
                                            <h3>                                                
                                                <span className="eagle-number-rotate" data-appear-animation="animateDigits" data-from="0" data-to="90" data-interval="5" data-before="" data-before-style="" data-after="" data-after-style="">90</span>
                                                <span className="eagle-fid">+</span>
                                            </h3>                                            
                                            <h6 className="eagle-fid-title">Secure Parcel</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </section>
            {/* <!-- Fid End --> */}

            {/* <!-- Team Start -->  */}
            <section className="team-section-three section-md">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-xl-6">
                            <div className="team-wrap">
                                <div className="eagle-heading-subheading animation-style2">
                                    <h4 className="eagle-subtitle">
                                        Why Choose Us
                                    </h4>
                                    <h2 className="eagle-title">Why Choose Eagle OBC?</h2>
                                    
                                </div>
                                <div className="about__list-box about__list-box-two">
                                        <ul className="list-wrap">
                                            <li><i className="flaticon-check"></i>Ultra-Fast Delivery: Next-flight-out (NFO) options worldwide.</li>
                                            <li><i className="flaticon-check"></i>Freelance Couriers: Global network of experienced OBC professionals.</li>
                                            <li><i className="flaticon-check"></i>Digital Convenience: Book, quote, and track—all online.</li>
                                            <li><i className="flaticon-check"></i>Secure & Reliable: Each shipment is escorted personally.</li>
                                        </ul>
                                    </div>
                                
                            </div>
                        </div>
                        <div className="col-md-12 col-xl-6">
                            <div className="team-contant">
                                <div className="row">
                                    <article className="eagle-team-style-2 col-md-6">
                                        <div className="pbminfotech-post-item">
                                            <div className="eagle-featured-wrap">
                                                <div className="eagle-featured-inner">
                                                    <div className="eagle-featured-img-wrapper">
                                                        <div className="eagle-featured-wrapper">
                                                            <img src="images/team-01.jpg" alt="" />
                                                        </div>
                                                    </div>      
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    </article>
                                    <article className="eagle-team-style-2 col-md-6">
                                        <div className="pbminfotech-post-item">
                                            <div className="eagle-featured-wrap">
                                                <div className="eagle-featured-inner">
                                                    <div className="eagle-featured-img-wrapper">
                                                        <div className="eagle-featured-wrapper">
                                                            <img src="images/team-02.jpg" alt="" />
                                                        </div>
                                                    </div>      
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    </article>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Team End --> */}

            


            {/* <!-- Testimonial Start --> */}
            <section className="testimonial-section-three section-lgx eagle-testimonial-style-2 d-none">
      <div className="container eagle-col-stretched-yes eagle-col-right">
        <div className="eagle-col-stretched-right">
          <div className="row">
            {/* Left Side - Heading */}
            <div className="eagle-testimonialbox-left col-xl-4 col-lg-12 eagle-column">
              <div className="eagle-testimonial-header-area">
                <div className="eagle-heading-subheading animation-style2">
                  <h4 className="eagle-subtitle">Feedback</h4>
                  <h2 className="eagle-title">
                    Hear from <br /> clients.
                  </h2>
                </div>
              </div>
            </div>

            {/* Right Side - Slider */}
            <div className="eagle-testimonialbox-right col-xl-8 col-lg-12 eagle-column">
              <Swiper
                modules={[Navigation, Autoplay]}
                autoplay={{ delay: 3000 }}
                loop={true}
                navigation={{
                  nextEl: ".testimonial-next",
                  prevEl: ".testimonial-prev",
                }}
                slidesPerView={2.4}
                spaceBetween={30}
                className="swiper-slider"
              >
                {testimonials.map((item, index) => (
                  <SwiperSlide key={index}>
                    <article className="eagle-testimonial-style-2">
                      <div className="pbminfotech-post-item">
                        <div className="pbminfotech-box-content">
                          <div className="pbminfotech-box-content-inner">
                            {/* Ratings */}
                            <div className="pbminfotech-box-star-ratings">
                              {Array.from({ length: 5 }).map((_, starIndex) => (
                                <i
                                  key={starIndex}
                                  className={`eagle-base-icon-star-1 ${
                                    starIndex < item.rating
                                      ? "eagle-active"
                                      : ""
                                  }`}
                                ></i>
                              ))}
                            </div>

                            {/* Feedback */}
                            <blockquote className="pbminfotech-testimonial-text">
                              <p>“{item.feedback}”</p>
                            </blockquote>

                            {/* Author */}
                            <div className="pbminfotech-box-author">
                              <h3 className="pbminfotech-box-title">
                                {item.name}
                              </h3>
                              <div className="pbminfotech-testimonial-detail">
                                {item.role}
                              </div>
                            </div>
                          </div>

                          {/* Decorative SVG */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="110.26"
                            height="119.26"
                            viewBox="0 0 110.26 119.26"
                          >
                            <path d="M108.1,119.16c-.26-8.6.74-17.23-2.14-25.7-3.74-11-11.48-17.58-22.09-21.22a143.36,143.36,0,0,0-15.71-4.77c-13.36-2.91-20.41-12-24.85-24-2.92-7.91-4.26-16.4-8.89-23.69A35.27,35.27,0,0,0,10,3.33C6.74,2.74,3.4,2.54.1,2.16c-.61-3.08,1.73-2,3-2,13.17-.06,26.33,0,39.5,0,21.5,0,43,0,64.5-.06,2.5,0,3.07.56,3.06,3.06-.09,37.67,0,75.33-.09,113C110.07,117.43,111.19,119.77,108.1,119.16Z"></path>
                          </svg>
                        </div>
                      </div>
                    </article>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - Rating Widget */}
      <div className="container">
        <div className="testimonial-wrapper">
          {/* Custom Nav */}
          <div className="testimonial-swiper-arrow d-inline-flex flex-row-reverse">
            <div className="testimonial-prev cursor-pointer">‹</div>
            <div className="testimonial-next cursor-pointer">›</div>
          </div>

          <div className="testimonial-widget-wrap">
            <div className="eagle-ihbox eagle-ihbox-style-2">
              <div className="eagle-ihbox-contents">
                <h2 className="eagle-element-title">4.82</h2>
                <div className="eagle-icon-wrap">
                  <div className="eagle-ihbox-icon">
                    <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-image">
                      <img src="images/rating-star.webp" alt="rating" />
                    </div>
                  </div>
                  <h4 className="eagle-element-subtitle">2488 Rating</h4>
                </div>
              </div>
              <div className="eagle-content-wrap"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
            {/* <!-- Testimonial End --> */}


          

        </div>
        {/* <!-- Page Content End --> */}
    </div>
  )
}
export default Aboutus;